export default {
  create_event: {
    title: 'Create a new event',
    event_name: 'Event Name',
    event_startDate: 'Start Date',
    create_button: 'Create event',
  },
};
